<template>
  <div class="open-pages">
    <v-card elevation="1">
      <div class="pages">
        <span
          class="page"
          :class="{ active: selectedPage.id === page.id }"
          v-ripple
          v-for="page in openPages"
          :key="'open-page-' + page.id"
          @click="onPageChange(page)"
        >
          <span>{{ page.name }}</span>
          <span v-for="user in onlineUsers" :key="user.id">
            <UserAvatar
              v-if="isUserOnPage(user.pageId, page.id)"
              :avatarUrl="user.avatarUrl"
              :fullName="user.fullName"
              :title="user.fullName + ' is working on this page'"
            />
          </span>
          <v-btn
            icon
            @click="
              onPageRemove(page);
              $event.stopPropagation();
            "
          >
            <v-icon small>mdi-close</v-icon>
          </v-btn>
        </span>
      </div>
    </v-card>
  </div>
</template>

<script>
import projectMixin from "./project-mixin";
import UserAvatar from "../UserAvatar";
export default {
  mixins: [projectMixin],
  components: { UserAvatar },
  methods: {
    onPageRemove(page) {
      this.REMOVE_OPEN_PAGE(page);
      let pageToOpen = null;
      if (this.openPages.length > 0) {
        pageToOpen = this.openPages[0];
      } else {
        pageToOpen = this.projectPages[0];
      }
      this.onPageChange(pageToOpen);
    },
    isUserOnPage(userPageId, pageId) {
      return userPageId == pageId;
    },
  },
};
</script>

<style scoped>
.open-pages {
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  width: 100%;
  height: 36px;
  border: none;
  margin-top: 120px;
  border-top: 1px solid #efefef;
  border-left: 1px solid #efefef;
  transition: margin-left 200ms;
  margin-left: 0px;
}
.pages {
  display: flex;
}
.page {
  padding-left: 2px;
  padding-right: 2px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-right: 1px solid #d4d4d4;
  cursor: pointer;
  transition: all 100ms;
}
.page:hover {
  background-color: #efefef;
}
.page.active {
  background-color: #efefef;
}
</style>